<template>
	<div class="product-center">
		<h1>{{ $t('home.智能场景 数字生活') }}</h1>
		<p>{{ $t('home.超多场景方案，个性化定制智能美好生活') }}</p>
		<!-- <button class="learn-more-btn">{{ $t('home.了解更多') }}</button> -->

		<!-- 轮播容器 -->
		<div class="swiper-container gallery-container">
			<div class="swiper-wrapper">
				<div class="swiper-slide" v-for="(img, index) in currentImages" :key="index">
					<div class="gallery-slide">
						<img :src="img" class="swiper-img" />
					</div>
				</div>
			</div>

			<!-- 导航按钮 -->
			<div class="swiper-button-prev">
				<img src="../assets/home/left.png" />
			</div>
			<div class="swiper-button-next">
				<img src="../assets/home/right.png" />
			</div>
		</div>
	</div>
</template>
<script>
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import { sceneApi, baseImgUrl } from '../netTool/api';

export default {
	data() {
		return {
			swiper: null,
			images: [], // 初始化为空数组
			images2: [],
			currentImages: [],
		};
	},
	async mounted() {
		await this.fetchSceneData();
		this.initSwiper();
	},
	watch: {
		'$i18n.locale': {
			handler(newLocale) {
				this.currentImages = newLocale == 'en' ? this.images2 : this.images
				// 先销毁已存在的实例
				if (this.swiper) {
					this.swiper.destroy();
				}
				this.initSwiper();
			},
			immediate: true
		}
	},
	methods: {
		async fetchSceneData() {
			try {
				const response = await sceneApi.getSceneList();
				if (response.success) {
					let list = response.scenes.map((item) => baseImgUrl + item.demo_image_url);
					this.images = list.filter((item) => !item.includes('en'));
					this.images2 = list.filter((item) => item.includes('en'));
					this.currentImages = this.$i18n.locale == 'en' ? this.images2 : this.images
				}
			} catch (error) {}
		},

		// initSwiper() {
		// 	this.$nextTick(() => {
		// 		this.swiper = new Swiper('.swiper-container', {
		// 			loop: true,
		// 			breakpoints: {
		// 				768: {
		// 					slidesPerView: 3,
		// 					spaceBetween: 20,
		// 					centeredSlides: true
		// 				},
		// 				0: {
		// 					slidesPerView: 1,
		// 					spaceBetween: 0,
		// 					centeredSlides: false
		// 				}
		// 			},
		// 			autoplay: {
		// 				delay: 5000,
		// 				disableOnInteraction: false,
		// 				pauseOnMouseEnter: true
		// 			},
		// 			pagination: {
		// 				el: '.swiper-pagination',
		// 				clickable: true,
		// 				renderBullet: (index, className) => {
		// 					return `<span class="${className} gallery-thumb">
		// 								<img src="${this.currentImages[index]}" alt="场景图片">
		// 							</span>`;
		// 				}
		// 			},
		// 			navigation: {
		// 				nextEl: '.swiper-button-next',
		// 				prevEl: '.swiper-button-prev'
		// 			}
		// 		});
		// 	});
		// }

		initSwiper() {
			this.$nextTick(() => {
				// 先销毁已存在的实例
				if (this.swiper) {
				this.swiper.destroy();
				}
				this.swiper = new Swiper('.swiper-container', {
				loop: true,
				// 添加触摸相关配置，确保可以正常滑动
				touchRatio: 1,
				touchAngle: 45,
				grabCursor: true,
				// 添加这两个配置提高滑动稳定性
				watchSlidesProgress: true,
				watchSlidesVisibility: true,
				// 基础配置
				breakpoints: {
					768: {
					slidesPerView: 3,
					spaceBetween: 20,
					centeredSlides: true
					},
					0: {
					slidesPerView: 1,
					spaceBetween: 0,
					centeredSlides: false
					}
				},
				// 自动播放配置
				autoplay: {
					delay: 5000,
					disableOnInteraction: false,
					pauseOnMouseEnter: true
				},
				// 分页器配置
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
					renderBullet: (index, className) => {
					return `<span class="${className} gallery-thumb">
								<img src="${this.currentImages[index]}" alt="场景图片">
							</span>`;
					}
				},
				// 导航按钮配置
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				}
				});
			});
		}
	},
	beforeDestroy() {
		if (this.swiper) {
			this.swiper.destroy();
		}
	}
};
</script>
<style scoped>
.product-center {
	text-align: center;
	padding: 40px 18px;
}

h1 {
	font-size: 2.5rem;
	margin-bottom: 30px;
}

p {
	color: #666;
	margin-bottom: 35px;
	font-size: 19px;
}

.learn-more-btn {
	padding: 10px 20px;
	border: 1px solid #ccc;
	border-radius: 20px;
	background-color: white;
	cursor: pointer;
}

.gallery-container {
	max-width: 100%;
	aspect-ratio: 3;
	margin: 30px 0;
	overflow: hidden;
}

.gallery-slide {
	align-items: center;
	height: 100%;
	display: flex;
	transition: all 0.5s ease;
	opacity: 0.7;
}

.swiper-img {
	width: 100%;
	height: 80%;
	object-fit: contain;
	border-radius: 12px;
}

.swiper-button-prev {
	left: 35px;
}
.swiper-button-prev::after {
	content: '' !important;
}
.swiper-button-next {
	right: 35px;
}
.swiper-button-next::after {
	content: '' !important;
}

@media (min-width: 768px) {
	.swiper-slide-next .gallery-slide {
		transform: translateX(45%);
	}

	.swiper-slide-prev .gallery-slide {
		transform: translateX(-45%);
	}

	.swiper-slide-active .gallery-slide {
		opacity: 1;
		transform: scale(1.55);
		overflow: visible;
	}
}

@media (max-width: 468px) {
	.swiper-button-prev {
		display: none;
	}
	.swiper-button-next {
		display: none;
	}

	.swiper-slide-active .gallery-slide {
		opacity: 1;
		transform: scale(1.8);
		overflow: visible;
	}
}
</style>
